// extracted by mini-css-extract-plugin
export default {"wrapper":"BackButton_wrapper__9V6-Y","button":"BackButton_button__pBnR8"};